import React from 'react';
import styled, { css } from 'styled-components';

import KeyboardArrowUpIcon from '@/assets/svg/keyboard_arrow_up.svg';
import KeyboardArrowDownIcon from '@/assets/svg/keyboard_arrow_down.svg';
import { DetailedCarMoreDetailsProps } from '@/components/DetailedCarMoreDetails/DetailedCarMoreDetails.types';
import { colors } from '@/constants/theme';
import useCollapse from '@/hooks/useCollapse';

function MoreDetailsMobileCollapse({ text }: DetailedCarMoreDetailsProps) {
  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();

  const firstIndent = text.split('\n')[0] + '<br><br>';
  const lastText = text.split('\n').slice(1).join('<br><br>');

  return (
    <Component>
      <FirstIndent dangerouslySetInnerHTML={{ __html: firstIndent }} />
      <CollapseContent {...getCollapseProps()}>
        <TextContent dangerouslySetInnerHTML={{ __html: lastText }} />
      </CollapseContent>
      {lastText && (
        <CollapseButton {...getToggleProps()}>
          <ButtonTitle isExpanded={isExpanded}>
            {isExpanded ? 'Свернуть' : 'Показать ещё'}
          </ButtonTitle>
          <ButtonIcon isExpanded={isExpanded}>
            {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </ButtonIcon>
        </CollapseButton>
      )}
    </Component>
  );
}

export default MoreDetailsMobileCollapse;

const Component = styled.div``;

const FirstIndent = styled.div`
  font-weight: 300;
  font-size: 16px;
  color: ${(props) => props.theme.black};
`;

const CollapseContent = styled.div``;

const TextContent = styled.div`
  font-weight: 300;
  font-size: 16px;
  margin-bottom: 16px;
  color: ${(props) => props.theme.black};
`;

const CollapseButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  opacity: 0.7;
  transition: 0.3s;

  &:hover {
    opacity: 1;
  }
`;

const ButtonTitle = styled.div<{ isExpanded: boolean }>`
  margin-right: 10px;
  line-height: 1;
  font-weight: 500;
  font-size: 16px;
  color: ${(props) => props.theme.black};

  ${({ isExpanded }) =>
    isExpanded
      ? css``
      : css`
          color: ${colors.main};
        `}
`;

const ButtonIcon = styled.div<{ isExpanded: boolean }>`
  margin-top: 5px;

  ${({ isExpanded }) =>
    isExpanded
      ? css`
          svg {
            fill: ${(props) => props.theme.black100};
          }
        `
      : css`
          svg {
            fill: ${colors.main};

            g {
              opacity: 1;
            }
          }
        `}
`;
